import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
@Component({
  selector: 'app-sopStatistical-evaluation',
  templateUrl: './sopStatistical.component.html',
  styleUrls: ['./sopStatistical.component.css']
})
export class SopStatisticalComponent implements OnInit {

  constructor(private router: Router ,public config: AppConfig) { }

  ngOnInit() {
  }

  onChildData(event: any) {
    switch(event.key){
      case 'processCompliance': this.router.navigate(['evaluation/observeSOP/processCompliance']);    break;
      case 'comments': this.router.navigate(['evaluation/observeSOP/sopComments']);    break;
      case 'individualData': this.router.navigate(['evaluation/observeSOP/sopIndividualOverview']);    break;
      case 'frequencyDistribution': this.router.navigate(['evaluation/observeSOP/frequencyDistribution']);    break;
      default: this.router.navigate(['evaluation/observeSOP/subStepCompliance']);    break;

    }
  }
}
